import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { ApplicationRouteURL } from '../config';
import { AuthService } from '../models/auth.service';

@Injectable()
export class HomePageAuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let home_URL = localStorage.getItem('home_URL');
    let urlData = this.authService.GetURL(
      home_URL != '' && home_URL != undefined ? home_URL : 'dashboard'
    );

    this.router.navigate([urlData]);
    return false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/guard/auth-guard-home-page.service.ts